<script lang="ts">
  import { UIEventSource } from "../../Logic/UIEventSource"
  import type { ValidatorType } from "./Validators"
  import Validators from "./Validators"

  import type { Feature } from "geojson"
  import type { SpecialVisualizationState } from "../SpecialVisualization"
  import DistanceInput from "./Helpers/DistanceInput.svelte"

  export let type: ValidatorType
  export let value: UIEventSource<string | object>
  export let feature: Feature = undefined
  export let args: (string | number | boolean)[] | any = undefined
  export let state: SpecialVisualizationState = undefined
  let validator = Validators.get(type)
  let validatorHelper = validator.inputHelper
</script>

{#if type === "distance"}
  <DistanceInput {value} {feature} {state} {args} />
{:else if validatorHelper !== undefined}
  <svelte:component this={validatorHelper} {value} {feature} {state} {args} on:submit />
{:else}
  <slot name="fallback" /> <!-- Used in the FilterWithView to inject the helper -->
{/if}
